import React, { useContext} from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ProtectedRoute from "./routes/ProtectedRoute";
import { initialRoutes } from "./routes/routes";
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { mobileRoutes } from './routes/mobileRoutes.js';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { ThemeContext } from './context/ThemeContext.js';

const generateRoutes = (routes) => {
  return routes.map(({ type, component: Component, children, ...rest }) => (
    <Route
      key={rest.path}
      {...rest}
      element={
        <ProtectedRoute type={type} title={rest?.title} image={rest?.image} isMobile={rest?.isMobile}>
          <Component />
        </ProtectedRoute>
      }
    >
      {children?.length ? generateRoutes(children) : null}
    </Route>
  ));
};

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

// const App = () => (
//   <Routes>{generateRoutes(initialRoutes())}</Routes>
// );
const App = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const { direction } = useContext(ThemeContext);

  const isMobilePath = ["/trade", "/chart", "/history", "/alerts", "/mailBox", "/report", "/news", "/accounts", "/settings", "/quote"].includes(location.pathname);


  return (
    <CacheProvider value={direction === 'rtl' ? cacheRtl : createCache({ key: 'css' })}>
      <div dir={direction}>
        <Routes>
          {isMobile ? (
            // <>
            //   {/* <Route path="*" element={<MobileLayout />} /> */}
            //   <Route path="*" element={<MobileLayout />} />
            // </>
            generateRoutes(mobileRoutes)
          ) : (
            generateRoutes(initialRoutes())
          )}
        </Routes>
      </div>
    </CacheProvider>
  );
};



export default App;